import { gql } from '@apollo/client'
import { userDataCompressed } from '../../../common/fragments'

export const GET_TASKS = gql`
	query getListingTasks(
		$listing_id: ID
		$thumbnailResolution: String = "128x128"
	) {
		getListingTasks(input: { listing_id: $listing_id }) {
			id
			type_id
			description
			assigned_by_user_id
			approval_required
			approved_by_user_id
			approval_at
			due_at
			is_completed
			created_by
			created_at
			modified_by
			modified_at
			is_deleted
			task_status_id

			# task_x_assigned_to
			assigned_to_type
			assigned_to_users {
				...userDataCompressed
				department
				is_deleted
			}
			assigned_to_department {
				id
				value
			}
		}
	}
	${userDataCompressed}
`

export const CREATE_TASK = gql`
	mutation createListingTask(
		$CreateTaskInput: CreateTaskInput!
		$thumbnailResolution: String = "128x128"
	) {
		createListingTask(input: $CreateTaskInput) {
			code
			success
			message
			task {
				id
				type_id
				description
				assigned_by_user_id
				approval_required
				approved_by_user_id
				approval_at
				due_at
				is_completed
				created_by
				created_at
				modified_by
				modified_at
				is_deleted
				task_status_id
				# task_x_assigned_to
				assigned_to_type
				assigned_to_users {
					...userDataCompressed
					is_deleted
					department
				}
				assigned_to_department {
					id
					value
				}
			}
		}
	}
	${userDataCompressed}
`
export const DELETE_TASK = gql`
	mutation deleteListingTask($id: ID) {
		deleteListingTask(id: $id) {
			code
			success
			message
		}
	}
`

export const UPDATE_TASK = gql`
	mutation updateListingTask(
		$UpdateTaskInput: UpdateTaskInput!
		$thumbnailResolution: String = "128x128"
	) {
		updateListingTask(input: $UpdateTaskInput) {
			code
			success
			message
			task {
				id
				type_id
				description
				assigned_by_user_id
				approval_required
				approved_by_user_id
				approval_at
				due_at
				is_completed
				created_by
				created_at
				modified_by
				modified_at
				is_deleted
				task_status_id

				# task_x_assigned_to
				assigned_to_type
				assigned_to_users {
					...userDataCompressed
					department
					is_deleted
				}
				assigned_to_department {
					id
					value
				}
			}
		}
	}
	${userDataCompressed}
`
